import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import '../../Styles/ResearchLabs.css';
import AppHeader from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';
import heroImage from '../../Assets/ResearchLabs/RSGCRL/RSGCRL-Hero.jpg';
import universityLogo from '../../Assets/ResearchLabs/RSGCRL/HostUniversity/Punjab-University-Logo.png';
import universityCampus from '../../Assets/ResearchLabs/RSGCRL/HostUniversity/Punjab-University-Campus.jpeg';
import Scope from './RSGCRL Components/Scope';
import ResearchDomains from './RSGCRL Components/ResearchDomains';
import Impact from './RSGCRL Components/Impact';
import PrincipalInvestigator from './RSGCRL Components/PrincipalInvestigator';
import OurTeam from './RSGCRL Components/OurTeam';
import SocialFeed from './RSGCRL Components/SocialFeed';

const { Title } = Typography;

const RemoteSensingGISClimaticResearchLab = () => (
  <>
    <AppHeader />
    <main>
      <div
        className="sarl-lab-hero"
        role="img"
        aria-label="Remote Sensing and GIS Climatic Research Lab"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <section className="sarl-host-section">
        <div className="sarl-host-inner">
          <Row gutter={[72, 40]} align="middle" justify="space-between">
            <Col xs={24} md={11}>
              <Title level={2} className="sarl-host-title">Host University</Title>
              <Divider className="ncgsa-divider" />
              <div className="sarl-host-identity">
                <img
                  src={universityLogo}
                  alt="University of the Punjab logo"
                  className="sarl-host-logo"
                />
                <Title level={5} className="sarl-host-name">
                  University of the Punjab, Lahore
                </Title>
              </div>
            </Col>
            <Col xs={24} md={10}>
              <img
                src={universityCampus}
                alt="University of the Punjab campus"
                className="sarl-host-campus"
              />
            </Col>
          </Row>
        </div>
      </section>
      <Scope />
      <ResearchDomains />
      <Impact />
      <PrincipalInvestigator />
      <OurTeam />
      <SocialFeed />
    </main>
    <FooterComponent />
  </>
);

export default RemoteSensingGISClimaticResearchLab;
